import axios from "axios";
import {Base_URL} from "../url"

export const fetchFundsCenters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/FundsCenter/GetAllFundsCenters`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching funds centers!";
  }
};

export const downloadFundsCentersExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/FundsCenter/DownloadFundsCentersExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading funds centers data!";
  }
};